import { estimatedColumnWidth } from "../helpers";
import { formatCurrency, formatDate } from "@/utils/helpers";

export default function getRevenueRecognitionDetailColumns() {

  const colArr = [
    {
      label: "Contract Number",
      value: true,
      columnId: "contractNumber",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Building Name",
      value: true,
      columnId: "buildingName",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Building Number",
      value: true,
      columnId: "buildingNumber",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Component Name",
      value: true,
      columnId: "componentName",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Component Number",
      value: true,
      columnId: "componentNumber",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Unit Name",
      value: true,
      columnId: "unitNames",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Unit Number",
      value: true,
      columnId: "unitNumbers",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Customer Name",
      value: true,
      columnId: "customerName",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Customer Number",
      value: true,
      columnId: "customerNumber",
      width: estimatedColumnWidth("number"),
      resizable: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Start Date",
      value: true,
      columnId: "startDate",
      width: estimatedColumnWidth("date"),
      resizable: true,
      formatter: (value) => formatDate(value || "")
    },
    {
      label: "End Date",
      value: true,
      columnId: "endDate",
      width: estimatedColumnWidth("date"),
      resizable: true,
      formatter: (value) => formatDate(value || "")
    },
    {
      label: "Break Date",
      value: true,
      columnId: "breakDate",
      width: estimatedColumnWidth("date"),
      resizable: true,
      formatter: (value) => formatDate(value || "")
    },
    {
      label: "Move Out Date",
      value: true,
      columnId: "moveOutDate",
      width: estimatedColumnWidth("date"),
      resizable: true,
      formatter: (value) => formatDate(value || "")
    },
    {
      label: "Recognised Till",
      value: true,
      columnId: "recognizedTill",
      width: estimatedColumnWidth("date"),
      resizable: true,
      formatter: (value) => formatDate(value || "")
    },
    {
      label: "Contract Amount",
      value: true,
      columnId: "contractAmount",
      width: estimatedColumnWidth("amount"),
      resizable: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Recognized Rental Revenue",
      value: true,
      columnId: "totalRecognizedRentalRevenue",
      width: estimatedColumnWidth("amount"),
      resizable: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Unrealized Rental Revenue",
      value: true,
      columnId: "unrealizedRevenue",
      width: estimatedColumnWidth("amount"),
      resizable: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Recognized Utility Revenue",
      value: true,
      columnId: "totalRecognizedUtilityRevenue",
      width: estimatedColumnWidth("amount"),
      resizable: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Unrealized Utility Revenue",
      value: true,
      columnId: "unrealizedUtilityRevenue",
      width: estimatedColumnWidth("amount"),
      resizable: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Revenue Status",
      value: true,
      columnId: "revenueStatus",
      width: estimatedColumnWidth("text"),
      resizable: true,
      formatter: (value) => String(value || "")
    }
  ];

  return colArr;
}
